import { Component, Input } from '@angular/core';
import { CustactGet } from '@app/services/custact.service';

@Component({
    selector: 'tt-work-details-plan-functions',
    templateUrl: './work-details-plan-functions.component.html',
    styleUrls: ['./work-details-plan-functions.component.css'],
})
export class WorkDetailsPlanFunctionsComponent {
    @Input()
    public params?: CustactGet;
}
